import { defineComponent } from 'vue';
import { useRoute } from 'vue-router';
export default defineComponent({
  setup: function () {
    var route = useRoute();
    var token = route.query.token || '';
    var redirectUrl = typeof route.query.redirectUrl === 'string' ? route.query.redirectUrl : '/user';
    if (token) {
      localStorage.setItem('TOKEN_UG_FE_CONTEST', token);
      setTimeout(function () {
        window.location.replace(redirectUrl);
      }, 1);
    }
  }
});